import { useAuth0 } from "@auth0/auth0-react";
import {
  Font,
} from "@react-pdf/renderer";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import { ReactComponent as PrintIcon } from "assets/icons/print_yah.svg";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../../../app/App.js";
import MournerItem from "../RecipientsMourners/MournerItem";
import "./NonRecipientsMourners.scss";

const NonRecipientsMourners = ({ values, setFieldValue }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  const [templateContent, setTemplateContent] = useState("");
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [printLoading, setPrintLoading] = useState(false);
  let selectedMourners = [];
  const mourners = selectedDeceased?.map((dec) => {
    if(!dec?.haveMourners ) return;
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        deceasedId: dec?._id,
        "Deceased name": dec?.name,
        "hebrew name of Death": dec?.hebrew_name_of_Death,
        "hebrew date of death": dec?.hebrew_date_of_death,
        "mother name": dec?.mother_name,
        "date of death":
          dec?.date_of_death &&
          moment(dec?.date_of_death).utcOffset("+0100").format(dateFormet),
        "mourners relation": item?.relation,
        gender: dec?.gender,
        "about the deceased": dec?.about_the_deceased,
        cemetery: dec?.cemetery,
        "plaque number": dec?.plaque_number,
        "First Name": item?.member_id?.first_name,
        "Middle Name": item?.member_id?.middle_name,
        "Last Name": item?.member_id?.last_name,
        "Hebrew Name": item?.member_id?.hebrew_name,
        Title: item?.member_id?.title,
        "Contact Gender": item?.member_id?.gender,
        Pronoun: item?.member_id?.pronounce,
        Status: item?.member_id?.social_status,
        "Date of Birth":
          item?.member_id?.date_of_birth &&
          moment(item?.member_id?.date_of_birth)
            .utcOffset("+0100")
            .format(dateFormet),
        "Mobile Number": item?.member_id?.mobile_number,
        "Home Number": item?.member_id?.home_phone,
        Email: item?.member_id?.email_address,
        "Emergency Contact Number": item?.member_id?.emergency_contact_number,
        Address: item?.member_id?.location?.formattedAddress,
        City: item?.member_id?.city,
        State: item?.member_id?.state,
        "Zip Code": item?.member_id?.zip_code,
        Occupation: item?.member_id?.occupation,
        Religion: item?.member_id?.religion,
        Relationship: item?.member_id?.relationship?.[0],
        Anniversary:
          item?.member_id?.anniversary_date &&
          moment(item?.member_id?.anniversary_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Bar-Bat Mitzvah":
          item?.member_id?.metva_date &&
          moment(item?.member_id?.metva_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Contact Tags": item?.member_id?.tags?.join(", "),
        "Account type": item?.member_id?.account?.payment?.account_type,
        Category: item?.member_id?.account?.payment?.account_sub_type?.title,
        "Billing type": item?.member_id?.account?.payment?.billing_type?.title,
        "Account name": item?.member_id?.account?.family_name,
        "Account ID": item?.member_id?.account?.account_id,
        "Family admin name": item?.member_id?.account?.admin_name,
        "Family admin contact": item?.member_id?.account?.admin_contact,
        "Old account ID": item?.member_id?.account?.old_account_id,
        "Active Address": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.location?.formattedAddress
          : "",
        "Active City": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.city
          : "",
        "Active State": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.state
          : "",
        "Active Zip code": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.zip_code
          : "",
        "Active Neighborhood": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.neighborhood
          : "",
        "Active Country": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.country
          : "",
        "Active Address Line2": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.active === true
          )?.addressLine2
          : "",
        "Billing Address": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.location?.formattedAddress
          : "",
        "Billing City": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.city
          : "",
        "Billing State": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.state
          : "",
        "Billing Zip code": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.zip_code
          : "",
        "Billing Neighborhood": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.neighborhood
          : "",
        "Billing Country": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.country
          : "",
        "Billing Address Line2": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
            (item) => item?.billing === true
          )?.addressLine2
          : "",
        "Account Tags": item?.member_id?.account?.tags?.join(", "),
        "Join Date":
          item?.member_id?.account?.join_date &&
          moment(item?.member_id?.account?.join_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Resign Date":
          item?.member_id?.account?.resign_date &&
          moment(item?.member_id?.account?.resign_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "next english yahrzeit":
          dec?.next_english_yhartzeit &&
          moment(dec?.next_english_yhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
        "next hebrew yahrzeit":
          dec?.next_hebrew_yhartzeit &&
          moment(dec?.next_hebrew_yhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
        "next observance yhartzeit":
          item?.nextObservanceYhartzeit &&
          moment(item?.nextObservanceYhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
      });
      return item;
    });
  });

  const listWithoutEmail = selectedMourners?.filter(
    (item) => !item?.member_id?.email_address && !item?.email
    );
  
  const listUnselectedMournersWithEmail = values?.unselectedMournersWithEmail;
  const mournersWithoutEmail = [...listWithoutEmail, ...listUnselectedMournersWithEmail]

  const getTemplateByType = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    try {
      const response = await FinancialSetting.getTemplateByType(
        token,
        "yehrzeit"
      );
      setTemplateContent(response?.result?.content?.replace(/&lt;/g, "<"));
      setFieldValue("template_id", response?.result?._id);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTemplateByType();
  }, []);
  const contentRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);
  const [templateContentImage, setTemplateContentImage] = useState("");

  useEffect(() => {
    setImageLoading(true);
    const regex = /<img.*?src="(.*?)"/;
    const match = regex.exec(templateContent);
    const imgSrc = match && match[1];
    if (imgSrc) {
      toDataUrl(imgSrc, function (myBase64) {
        return setTemplateContentImage(myBase64);
      });
    }
    setImageLoading(false);
  }, [templateContent]);

  function toDataUrl(url, callback) {
    if (url !== null) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
  }




  Font.register({
    family: "Roboto",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxK.woff2",
        fontWeight: 400,
      },
      {
        src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
        fontWeight: 700,
      },
    ],
  });




  const printHandler = async ({ item, type }) => {
    if(printLoading) return;
    setPrintLoading(true);
    const token = await getAccessTokenSilently();
    const nonRecipientsData = type === "all" ? mournersWithoutEmail : [item];
    const deceasedData = nonRecipientsData?.map((decease) => {
      return {
        deceasedId: decease?.deceasedId,
        memberIds: decease?.member_id?._id ? [decease?.member_id?._id] : undefined,
        nonMember:
          (!decease?.member_id?._id && decease?._id) ? [decease?._id] : undefined,
      };
    });

    const bodyData = {
      deceased: deceasedData,
      templateId: values?.template_id,
    };


    try {
      const response = await FinancialSetting.printMournerDeceased(
        token,
        bodyData
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "deceased.pdf");
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      setPrintedFiles(type, item)
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
    } finally {
      setPrintLoading(false);
    }
  }


  const setPrintedFiles = (type, item) => {
    if (type === "all") {
      setFieldValue(
        "printed",
        mournersWithoutEmail?.map((item) => item?._id)
      );
      return;
    }
    if (!item?._id) return;
    setFieldValue("printed", [...values?.printed, item?._id]);
  }


  return (
    <div className="non_recipients" ref={contentRef}>
      <div className="non_recipients__title">
        <h3> Non-Recipients </h3>
        <h3>{mournersWithoutEmail?.length}</h3>
      </div>
      <div className="listText">
        The following is a list of the {mournersWithoutEmail?.length}{" "}
        recipients.
      </div>
      <button type="button" className="printAll_btn" onClick={() => {
        printHandler({
          type: "all"
        })
      }}
      disabled={printLoading || !mournersWithoutEmail?.length}
      >
        {printLoading ? (
          <div
            className="spinner-border spinner-border-sm text-primary"
            role="status"
          />
        ) : (
          <>
            <PrintIcon className="mr-3" /> Print All
          </>
        )}
      </button>
      <hr />
      <div className="mourner_list">
        {mournersWithoutEmail?.map((item) => (
          <MournerItem
            key={item?._id}
            id={item?._id}
            item={item}
            profile_img={item?.member_id?.profile_img}
            full_name={item?.member_id?.full_name}
            first_name={item?.member_id?.first_name}
            last_name={item?.member_id?.last_name}
            values={values}
            setFieldValue={setFieldValue}
            loading={loading}
            imageLoading={imageLoading}
            printHandler={printHandler}
          />
        ))}
      </div>
    </div>
  );
};

export default NonRecipientsMourners;
